import React from 'react';

/* A note when using this component - if you not pass a fill color the icon will use the default fill color. */

const IconTiktokVerifiedBadge = props => (
  <svg data-dir="ltr" width={16} height={16} viewBox="0 0 48 48" {...props} fill="none">
    <circle cx={24} cy={24} r={24} fill={!props.fill ? '#20D5EC' : props.fill} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.121 15.879a3 3 0 0 1 0 4.242l-13.5 13.5a3 3 0 0 1-4.242 0l-8.5-8.5a3 3 0 1 1 4.242-4.242l6.379 6.378L32.879 15.88a3 3 0 0 1 4.242 0Z"
      fill="#fff"
    />
  </svg>
);

export default IconTiktokVerifiedBadge;
